import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon, IStackTokens, Toggle, ComboBox, IComboBoxOption, IComboBox, TextField, IContextualMenuItem, DetailsList, SelectionMode, DetailsListLayoutMode, ISelection, MarqueeSelection, KeyCodes } from '@fluentui/react';
import { getEventListeners } from 'events';
import React from 'react';
import styles from '../styles/pokemon.module.scss';
import { ExecuteQuery } from '../services/Globals';

export interface IsqlComponentProps {
    apiUrl: string;
}

export interface IsqlComponentState {
    query: string;
    items: any[];
    multiple: boolean;
};

export default class SqlComponent extends React.Component<IsqlComponentProps, IsqlComponentState> {
    constructor(props: IsqlComponentProps) {
        super(props);

        this.SubmitQuery = this.SubmitQuery.bind(this);
        this.SubmitMultiQuery = this.SubmitMultiQuery.bind(this);

        this.state = {query: "select * from cards limit 1" , items: [], multiple: false};
    }

    componentDidUpdate(prevProps: Readonly<IsqlComponentProps>, prevState: Readonly<IsqlComponentState>, snapshot?: any): void {
        if (prevState.items != this.state.items) {
            setTimeout(() => {
                let resizeButtons = document.getElementsByClassName("ms-DetailsHeader-cellSizer");

                for (let i=0; i<resizeButtons.length; i++) {    
                    resizeButtons[i].classList.add("is-resizing");
                    resizeButtons[i].dispatchEvent(new MouseEvent("dblclick", {clientX:0, clientY:0, composed:true, detail:2, screenX:0, screenY:0}));
                    resizeButtons[i].dispatchEvent(new MouseEvent("click"));
                }        
            }, 1000);
        }
    }

    private SubmitQuery(tquery:string=null) {
        let q = tquery ? tquery : this.state.query;
        ExecuteQuery(q,this.props.apiUrl).then(resp => {
            this.setState({items: resp});
        }).catch(err => {
            alert(err);
        });
    }

    private SubmitMultiQuery() {
        let tempcompiledresp = "";
        const tq = this.state.query;

        tq.split('\n').forEach(line => {
            ExecuteQuery(line,this.props.apiUrl).then(resp => {
                tempcompiledresp += `OK => ${line}\n`;
                this.setState({query: tempcompiledresp});
            }).catch(err => {
                tempcompiledresp = `ERROR ${err} ${line}\n${tempcompiledresp}`;
                this.setState({query: tempcompiledresp});
            });
        });
    }

    public render(): React.ReactElement<IsqlComponentProps> {
        console.log(this.state);
        return (  
            <Stack>
                <Stack horizontal style={{margin:15,width:"100%"}}>
                    <Toggle label='Complex / Multiple' inlineLabel onChange={() => this.setState({multiple: !this.state.multiple})}/>
                </Stack>
                {this.state.multiple ? 
                <Stack horizontal style={{margin:15,width:"100%"}}>
                    <TextField style={{overflowY:"scroll"}}  rows={10} multiline value={this.state.query} styles={{root: {width:"90%"}}} onChange={(e,v)=>{this.setState({query:v})}}/>
                    <PrimaryButton text="Submit" onClick={this.SubmitMultiQuery} />
                </Stack> :
                <Stack horizontal style={{margin:15,width:"100%"}}>
                    <TextField value={this.state.query} styles={{root: {width:"90%"}}} onChange={(e,v)=>{this.setState({query:v})}} onKeyUp={(e) => { if (e.code === "Enter"){ this.SubmitQuery(); }}}/>
                    <PrimaryButton text="Submit" onClick={() => { this.SubmitQuery();} } />
                </Stack>}
                <Stack horizontal style={{margin:15,width:"100%"}}>
                    {this.state.items.length > 0 && 
                    
                        <table className={styles.gridtable}>
                            <tr className={styles.gridtr}>
                                {
                                    Object.keys(this.state.items[0]).map(key => {
                                    return <th className={styles.gridth}>
                                            {key}
                                           </th>        
                                })}
                            </tr>
                            {this.state.items.map(item => {
                                return <tr className={styles.gridtr}>
                                            {Object.values(item).map(val => {
                                                return <td className={styles.gridtd}>{val as string}</td>
                                            })}
                                       </tr>
                            })}
                        </table>

                    }
                </Stack>
            </Stack> 
        );
    }
}